import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/ambiente/ambiental_background.jpg";
import ImageForestacion from "../img/ambiente/2.Capsula-AB-Forestacion.jpg";
import ImageBioswale from "../img/ambiente/2.Capsula-AB-Bioswale.jpg";
import ImageHumedalA from "../img/ambiente/2.Capsula-AB-Humedal-3a.jpg";
import ImageHumedalB from "../img/ambiente/2.Capsula-AB-Humedal-3b.jpg";
import ImageModulos from "../img/ambiente/2.Capsula-AB-PTAR.jpg";

//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [{
    id: "1",
    title:"66.6 Ha",
    subtitle:"de Forestación",
    image: ImageForestacion,
    x: "50%",
    y: "20%"
}, {
    id: "2",
    title:"55.623 m²",
    subtitle:"Bioswale",
    image: ImageBioswale,
    x: "36%",
    y: "54%"
}, {
    id: "3a",
    title:"152.741 m²",
    subtitle:"Humedales",
    image: ImageHumedalA,
    x: "6%",
    y: "39%"
}, {
    id: "3b",
    title:"152.741 m²",
    subtitle:"Humedales",
    image: ImageHumedalB,
    x: "6%",
    y: "55%"
}, {
    id: "4",
    title:"PTAR",
    subtitle:"2 MODULOS PARA 3.600 VIVIENDAS",
    image: ImageModulos,
    x: "13%",
    y: "35%"
}];

export default function AmbientalPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"AMBIENTAL"} subtitle={"ZONA DE PROTECCIÓN AMBIENTAL"} />
            <ButtonLeftTitle title={"87 Ha"} subtitle={"Protección"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}
                        />
                    )
                })
            }
        </div>
    );
}